import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        roleId: null,
        ds: {},   //数据源
    },
    getters: {
        ['RoleDependencyRelationGetLoading'](state) {
            return state.loading;
        },
        ['RoleDependencyRelationGetRoleId'](state) {
            return state.roleId;
        }
    },
    mutations: {
        ['RoleDependencyRelationSetLoading'](state, loading) {
            this.loading = loading;
        },
        ['RoleDependencyRelationSetRoleId'](state, roleId) {
            state.roleId = roleId;
        },
        ['RoleDependencyRelationSetDS'](state, ds) {
            state.ds = ds;
        }
    },
    actions: {
        async selectDSByRoleId({commit}, roleId) {
            commit('RoleDependencyRelationSetLoading', true);
            try {
                let result = await OrganizationServer.role.dependency(roleId);
                if (result.data.code === '200') {
                    commit('RoleDependencyRelationSetDS', result.data.data[0]);
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                console.log(e);
                return false;
            } finally {
                commit('RoleDependencyRelationSetLoading', false);
            }

        }
    }
}